import React, { useState, useEffect } from 'react';
import './SuccessScreen.css';

export default function SuccessScreen({ panelId, onRedirect }) {
  const [countdown, setCountdown] = useState(3);

  // Countdown und Auto-Redirect nur wenn Panel-ID vorhanden
  useEffect(() => {
    if (!panelId || !onRedirect) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [panelId, onRedirect]);
  return (
    <div className="success-screen-overlay">
      <div className="success-screen-container">
        {/* Success Icon */}
        <div className="success-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="url(#successGradient)" fillOpacity="0.2"/>
            <circle cx="32" cy="32" r="30" stroke="url(#successGradient)" strokeWidth="3"/>
            <path d="M20 32L28 40L44 24" stroke="url(#successGradient)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
              <linearGradient id="successGradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#7c4dff"/>
                <stop offset="100%" stopColor="#6845A5"/>
              </linearGradient>
            </defs>
          </svg>
        </div>

        <h1 className="success-title">Vielen Dank für Ihre Teilnahme!</h1>

        <p className="success-message">
          Ihre Antworten wurden erfolgreich übermittelt und helfen uns, unsere Produkte und Services zu verbessern.
        </p>

        <p className="success-submessage">
          Wir schätzen Ihre Zeit und Ihr wertvolles Feedback sehr.
        </p>

        {/* Countdown-Nachricht (nur bei Panel-Teilnehmern) */}
        {panelId && (
          <div className="redirect-countdown">
            <p className="redirect-message">
              Sie werden in <strong>{countdown}</strong> Sekunde{countdown !== 1 ? 'n' : ''} automatisch weitergeleitet...
            </p>
            {/* Manueller Fallback-Link falls Auto-Redirect fehlschlägt */}
            <p className="redirect-fallback" style={{ marginTop: '10px', fontSize: '14px', opacity: 0.8 }}>
              Falls die Weiterleitung nicht funktioniert,{' '}
              <a 
                href={`https://survey.maximiles.com/complete?p=155033_8dbe24e4&m=${panelId}`}
                style={{ color: '#7c4dff', textDecoration: 'underline' }}
              >
                klicken Sie bitte hier
              </a>
            </p>
          </div>
        )}

        {/* CTA Button (nur wenn KEIN Panel-Redirect) */}
        {!panelId && (
          <a
            href="https://fairment.de"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Zu fairment.de
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 3L13 10L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        )}
      </div>
    </div>
  );
}
